import downloadFile from 'app/utils/downloadFile';

const exportZipFile = (zip, filename) => {
  const zipFileData = zip.generate({ type: 'blob' });
  const zipName = `${filename}.zip`;
  downloadFile(zipFileData, zipName, false);
};

export default exportZipFile;
